import React, { useState } from 'react'
import './styles.scss'
import Composer from 'components/InChatView/Composer'
import { lang } from 'utils/helpers'

const LocalEditor = ({ conversationId, channel, composer, parentId, sendMessageAlt }) => {
  const [editing, setEditing] = useState(false)
  const onToggleEditing = () => setEditing(!editing)

  return (
    <div className='local-editor'>
      { !editing
        ?
        <div className='preview-text' onClick={onToggleEditing}>
          <span>
            {lang('dashboard_write-message')}
          </span>
        </div>
        :
        <Composer
          conversationId={conversationId}
          channel={channel}
          isThread
          composer={composer}
          parentId={parentId}
          sendMessageAlt={sendMessageAlt}
        />
      }
    </div>
  )
}

export default LocalEditor